import BlVoucherCardSmallMv from './BlVoucherCardSmallMv.vue'

BlVoucherCardSmallMv.install = function(Vue) {
  Vue.component(BlVoucherCardSmallMv.name, BlVoucherCardSmallMv)
}

export default BlVoucherCardSmallMv
